module.exports = __webpack_public_path__ + "media/images/icon__checkmark@3x-bbb34129a36e9f382014daf6970e3b02.png";